import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Robustand = () => {
  return (
    <div className="Robustand p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>Our Versatile Flutter Mobile App Development Services</h2>
                        <p>As a bespoke Flutter application development company, we can turn your concepts into meaningful digital experiences. The mission is clear: to enhance brands by utilizing technology for impactful and positive change. Here are the Flutter app development services that we offer:</p>
                        <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let’s Build Your Flutter App</Link>
                    </Col>
                    <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
                        <div className="robustscroll">
                        <div className="robust-box">
                            <div className="robust-content">
                                <h4>Flutter App Consultation and Ideation</h4>
                                <p>With a dedicated Flutter developer by your side, we ensure your ideas flourish into digital brilliance. In the Flutter app consultation, we attentively listen to your vision, offering personalized advice to build a full-fledged Flutter app.</p>
                            </div>
                            <div className="robust-content">
                                <h4>Flutter UI/UX Design</h4>
                                <p>Enhance your app's UI in Flutter by collaborating with us - the best Flutter app development company with expertise in Flutter UI/UX design. Collaborating on your Flutter app development projects, we craft visually stunning and user-friendly interfaces, ensuring a smooth and delightful digital experience for your audience.</p>
                            </div>
                            <div className="robust-content">
                                <h4>Flutter App Development</h4>
                                <p>Our Flutter mobile app development services are crafted to establish a multi-platform presence. From identifying the ideal product-market fit to smoothly deploying your application across various platforms, our Flutter developers assist in designing, developing, testing, and launching full-fledged Flutter apps.</p>
                            </div>
                            <div className="robust-content">
                                <h4>Flutter App Migration</h4>
                                <p>We can help streamline your app presence through Flutter App Migration. Specializing in migration for iOS and Flutter Android app development, our experts ensure a smooth transition across platforms and operating systems for your existing applications.</p>
                            </div>
                        </div>
                        </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Robustand